import Api from '../utils/Api';

const get = (caller, id = null) => {
    let url = '/packages';
    if (id) {
        url += `/${id}`;
    }

    return Api.makeRequest(url, 'GET', id, caller);
};

const getOwned = (caller) => {
    let url = '/users/me/packages';
    return Api.makeRequest(url, 'GET', null, caller);
};


const getMeditations = (caller, id) => {
    return Api.makeRequest(`/packages/${id}/meditations`, 'GET', null, caller, id);
};

export { get, getOwned, getMeditations };


// WEBPACK FOOTER //
// ./src/models/Package.js